import { Loader2 } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface StatusToggleBadgeProps {
  isActive: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  onClick: () => void;
  activeLabel?: string;
  inactiveLabel?: string;
  className?: string;
}

export function StatusToggleBadge({
  isActive,
  isLoading = false,
  disabled = false,
  onClick,
  activeLabel = "Aktif",
  inactiveLabel = "Nonaktif",
  className,
}: StatusToggleBadgeProps) {
  const isInteractive = !disabled && !isLoading;

  return (
    <button
      type="button"
      disabled={!isInteractive}
      onClick={(e) => {
        e.stopPropagation();
        if (isInteractive) onClick();
      }}
      className={cn(
        "inline-flex select-none items-center",
        !isInteractive ? "cursor-not-allowed opacity-60" : "cursor-pointer",
        className,
      )}
    >
      <Badge
        variant={isActive ? "default" : "outline"}
        className={cn(
          "w-[76px] justify-center py-0.5 text-xs transition-colors",
          isInteractive && "hover:opacity-80",
        )}
      >
        {isLoading ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <span>{isActive ? activeLabel : inactiveLabel}</span>
        )}
      </Badge>
    </button>
  );
}
